// @ts-nocheck
import { Card, CardBody } from '@components/card/card';
import { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ModalComponent from '@components/Modal/ModalComponent';
import OrganizationForm from './OrganizationForm';
import useGetOrganizations from '@hooks/HR/use-get-organizations';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import EditFormDepartments from './Update';
import AddDepartment from './Add';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable';
import useLookupOrgType from '@hooks/Lookups/use-Lookup-OrgType';
import useLookupOrgClass from '@hooks/Lookups/use-Lookup-OrgClass';
import NeatixModal from '@components/Modal/NeatixModal';
import { Modal, Tab, Nav } from 'react-bootstrap';
import OperatingUnitsHelpModal from './OperatingUnitsHelpModal';
import OrganizationsCards from './OrganizationsCards';
import OrganizationsTable from './OrganizationsTable';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [Show, setShow] = useState(false);
  const [Show2, setShow2] = useState(false);
  const { t, i18n } = useTranslation();
  const [id, setId] = useState('');
  const [search, setSearch] = useState('');
  const [orgType, setOrgType] = useState(null);
  const [filterBy, setFilterBy] = useState('all'); // 'all', 'type', 'operatingUnit'
  const { OrgTypeList } = useLookupOrgType();
  const { Organizations, loading, error } = useGetOrganizations();
  const { dataORGCLASS } = useLookupOrgClass();
  const [ShowHelpModal, setShowHelpModal] = useState(false); // حالة المودال الجديد
  const [viewMode, setViewMode] = useState('table'); // 'table' أو 'cards'

  // الشركة الأم (النوع 30)
  const mainCompany = Organizations?.find(org => org.type === '30');

  // وحدات التشغيل
  const operatingUnits = Organizations?.filter(org => org.organizationInformation?.includes('OPERATING_UNIT'));

  // تحسين التصفية مع معالجة خاصة للشركة الأم ووحدات التشغيل
  const filteredOrg = Organizations?.slice()?.filter(emp => {
    const searchLowerCase = search.toLowerCase();
    const matchesSearch =
      emp.name2?.toLowerCase().includes(searchLowerCase) ||
      emp.name?.toLowerCase().includes(searchLowerCase) ||
      emp.locationName?.toString().includes(searchLowerCase) ||
      emp.locationName2?.toString().includes(searchLowerCase);

    // التصفية حسب النوع
    const matchesType = orgType === null ? true : emp.type === orgType;

    // التصفية حسب وحدات التشغيل
    const matchesOperatingUnit =
      filterBy === 'operatingUnit' ? emp.organizationInformation?.includes('OPERATING_UNIT') : true;

    return matchesSearch && matchesType && matchesOperatingUnit;
  });

  // ترتيب القائمة: الشركة الأم أولاً، ثم وحدات التشغيل، ثم الباقي
  const sortedAndFilteredOrg = filteredOrg?.sort((a, b) => {
    const aIsMainCompany = a.type === '30';
    const bIsMainCompany = b.type === '30';
    const aIsOperatingUnit = a.organizationInformation?.includes('OPERATING_UNIT');
    const bIsOperatingUnit = b.organizationInformation?.includes('OPERATING_UNIT');

    // الشركة الأم تأتي أولاً
    if (aIsMainCompany && !bIsMainCompany) return -1;
    if (!aIsMainCompany && bIsMainCompany) return 1;

    // إذا كانت كلاهما شركة أم أو لا، نرتب وحدات التشغيل ثانياً
    if (aIsOperatingUnit && !bIsOperatingUnit) return -1;
    if (!aIsOperatingUnit && bIsOperatingUnit) return 1;

    // إذا كانت نفس النوع، نرتب أبجدياً
    const aName = (i18n.language === 'en' ? a.name : a.name2) || '';
    const bName = (i18n.language === 'en' ? b.name : b.name2) || '';
    return aName.localeCompare(bName);
  });

  // تحسين قائمة الأنواع مع إبراز الشركة الأم
  const enhancedOrgTypeList = OrgTypeList?.map(type => ({
    ...type,
    isMainCompany: type.value === '30',
    description: type.value === '30' ? 'شركة واحدة فقط - الشركة الأم' : ''
  }));

  // تحسين أعمدة الجدول
  const columns = [
    {
      title: t('Name'),
      key: 'Name',
      className: 'w-25',
      sortable: true
    },
    {
      title: t('location'),
      key: 'location',
      className: 'w-20',
      sortable: true
    },
    {
      title: t('Type'),
      key: 'Type',
      className: 'w-20',
      sortable: true
    },
    {
      title: t('Classification'),
      key: 'Classification',
      className: 'w-20',
      sortable: false
    },
    {
      title: '',
      key: 'action',
      className: 'text-end w-15',
      sortable: false
    }
  ];

  // تحسين بيانات الجدول مع إبراز الشركة الأم ووحدات التشغيل
  const tableData = sortedAndFilteredOrg?.map(item => {
    const isMainCompany = item.type === '30';
    const isOperatingUnit = item.organizationInformation?.includes('OPERATING_UNIT');
    const rowClass = isMainCompany ? 'table-warning fw-bold' : isOperatingUnit ? 'table-info' : '';

    return {
      Name: (
        <div className='d-flex align-items-center'>
          {isMainCompany && <i className='fas fa-crown text-warning me-2' title='الشركة الأم'></i>}
          {isOperatingUnit && !isMainCompany && <i className='fas fa-cogs text-info me-2' title='وحدة تشغيل'></i>}
          <span className={isMainCompany ? 'fw-bold' : ''}>{i18n.language === 'en' ? item.name : item.name2}</span>
        </div>
      ),
      location: i18n.language === 'en' ? item.locationName : item.locationName2,
      Type: (
        <div className='d-flex align-items-center'>
          <span className={isMainCompany ? 'fw-bold' : ''}>{OrgTypeList?.find(f => f.value === item.type)?.label}</span>
          {isMainCompany && <span className='badge bg-warning text-dark ms-2 fs-10'>رئيسي</span>}
          {isOperatingUnit && !isMainCompany && <span className='badge bg-info text-white ms-2 fs-10'>تشغيل</span>}
        </div>
      ),
      Classification: item.organizationInformation ? (
        <ul className='list-unstyled mb-0 p-0 d-flex flex-wrap gap-1'>
          {item?.organizationInformation?.split(',')?.map((info, idx) => {
            const isOperatingUnit = info === 'OPERATING_UNIT';
            const isMainCompanyType = item.type === '30';

            return (
              <li
                key={idx}
                className={`badge border px-2 pt-5px pb-5px rounded fs-12px me-1 
                  ${
                    isOperatingUnit
                      ? 'bg-info text-white fw-bold border-info'
                      : isMainCompanyType
                      ? 'bg-warning text-dark fw-bold'
                      : 'border-theme text-theme'
                  }`}
              >
                {dataORGCLASS?.find(f => f.value === info)?.label || ''}
              </li>
            );
          })}
        </ul>
      ) : (
        <span className='text-muted'>-</span>
      ),
      action: (
        <>
          {HasPermission('EditHrDepartments') && (
            <button
              type='button'
              className={`btn btn-sm ${isMainCompany ? 'btn-warning' : isOperatingUnit ? 'btn-info' : 'btn-theme'}`}
              onClick={() => {
                setId(item.id);
                setShow2(true);
              }}
            >
              <i className='far fa-lg fa-fw fa-edit mx-1'></i>
              {t('Button.Edit')}
            </button>
          )}
        </>
      ),
      rowClass
    };
  });

  // إحصائيات للمنظمات المرتبة
  const mainCompaniesCount = sortedAndFilteredOrg?.filter(org => org.type === '30').length || 0;
  const operatingUnitsCount =
    sortedAndFilteredOrg?.filter(org => org.organizationInformation?.includes('OPERATING_UNIT')).length || 0;
  const otherOrgsCount = (sortedAndFilteredOrg?.length || 0) - mainCompaniesCount - operatingUnitsCount;

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'OrganizationalUnits',
              link: null
            }
          ]}
          PageName='OrganizationalUnits'
        />
        <div className='ms-auto'>
          {HasPermission('AddHrDepartments') && (
            <Link
              to=''
              data-bs-toggle='modal'
              data-bs-target='#modalXl'
              className='btn btn-theme me-1'
              onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw'></i> {t('NewOrganizationalUnit')}
            </Link>
          )}
        </div>
      </div>

      <Card className='border-1'>
        <Loading loading={loading} error={error}>
          <CardBody>
            {/* بطاقة الشركة الأم */}
            <Card className='border-0 bg-warning bg-opacity-25 mb-3 shadow-sm'>
              <CardBody>
                {mainCompany && (
                  <div className='d-flex align-items-center'>
                    <i className='fas fa-building-columns fa-2x me-3 text-warning'></i>
                    <div className='flex-grow-1'>
                      <h5 className='mb-1 fw-bold'>{i18n.language === 'en' ? mainCompany.name : mainCompany.name2}</h5>
                      <p className='mb-0 text-muted'>
                        الشركة الرئيسية في النظام | الموقع:{' '}
                        {i18n.language === 'en' ? mainCompany.locationName : mainCompany.locationName2}
                      </p>
                    </div>
                    {HasPermission('EditHrDepartments') && (
                      <button
                        type='button'
                        className='btn btn-sm btn-warning'
                        onClick={() => {
                          setId(mainCompany.id);
                          setShow2(true);
                        }}
                      >
                        <i className='far fa-lg fa-fw fa-edit mx-1'></i>
                        {t('Button.Edit')}
                      </button>
                    )}
                  </div>
                )}
              </CardBody>
            </Card>
            {/* بطاقة وحدات التشغيل */}
            <Card className='border-0 bg-info bg-opacity-25 mb-3 shadow-sm'>
              <CardBody>
                {operatingUnits && (
                  <div className='d-flex align-items-center'>
                    <i className='fas fa-cogs fa-2x me-3 text-info'></i>
                    <div className='flex-grow-1'>
                      <h5 className='alert-heading mb-1'>وحدات التشغيل ({operatingUnits.length})</h5>
                      <p className='mb-0'>الوحدات المسؤولة عن العمليات التشغيلية في النظام</p>
                    </div>
                    <button type='button' className='btn btn-outline-info  ' onClick={() => setShowHelpModal(true)}>
                      <i className='fas fa-question-circle  fa-lg'></i>
                    </button>
                  </div>
                )}
              </CardBody>
            </Card>

            {/* محسنات التصفية */}
            <div className='row mb-3'>
              <div className='col-lg-4'>
                <label className='form-label fw-bold   mb-2'>تصفية حسب النوع</label>
                <Select
                  classNamePrefix='react-select'
                  className='w-100'
                  isSearchable={true}
                  isClearable
                  options={enhancedOrgTypeList}
                  value={enhancedOrgTypeList?.find(f => f.value === orgType) || null}
                  onChange={option => {
                    setOrgType(option === null ? null : option.value);
                    setFilterBy('type');
                  }}
                  formatOptionLabel={({ label, isMainCompany, description }) => (
                    <div>
                      <div className='fw-bold'>{label}</div>
                      {isMainCompany && <div className='text-muted small'>{description}</div>}
                    </div>
                  )}
                  placeholder='اختر النوع'
                />
              </div>

              <div className='col-lg-4'>
                <label className='form-label fw-bold   mb-2'>تصفية سريعة</label>
                <div className='d-flex gap-2 flex-wrap'>
                  <button
                    type='button'
                    className={`btn btn-sm ${filterBy === 'all' ? 'btn-theme' : 'btn-outline-theme'}`}
                    onClick={() => {
                      setFilterBy('all');
                      setOrgType(null);
                    }}
                  >
                    الكل
                  </button>
                  <button
                    type='button'
                    className={`btn btn-sm ${
                      filterBy === 'type' && orgType === '30' ? 'btn-warning' : 'btn-outline-warning'
                    }`}
                    onClick={() => {
                      setFilterBy('type');
                      setOrgType('30');
                    }}
                  >
                    الشركة الرئيسية
                  </button>
                  <button
                    type='button'
                    className={`btn btn-sm ${filterBy === 'operatingUnit' ? 'btn-info' : 'btn-outline-info'}`}
                    onClick={() => {
                      setFilterBy('operatingUnit');
                      setOrgType(null);
                    }}
                  >
                    وحدات التشغيل ({operatingUnits?.length || 0})
                  </button>
                </div>
              </div>

              <div className='col-lg-4'>
                <label className='form-label fw-bold   mb-2'>{t('Search')}</label>
                <div className='input-group'>
                  <span className='input-group-text bg-secondary bg-opacity-50 border-end-0'>
                    <i className='fa fa-search text-theme'></i>
                  </span>
                  <input
                    type='text'
                    autoComplete='off'
                    className='form-control border-start-0'
                    placeholder='ابحث بالاسم أو الموقع...'
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                  />
                  {search && (
                    <button className='btn btn-outline-secondary' type='button' onClick={() => setSearch('')}>
                      <i className='fa fa-times'></i>
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* إحصائيات سريعة */}
            <div className='row mb-3'>
              <div className='col-12'>
                <div className='d-flex flex-wrap gap-3'>
                  <div className='bg-secondary bg-opacity-50 rounded p-2 px-3'>
                    <small className='text-muted'>إجمالي الوحدات:</small>
                    <div className='fw-bold'>{sortedAndFilteredOrg?.length || 0}</div>
                  </div>
                  <div className='bg-warning bg-opacity-10 rounded p-2 px-3 border border-warning'>
                    <small className='text-warning'>الشركة الرئيسية</small>
                    <div className='fw-bold text-warning'>{mainCompaniesCount}</div>
                  </div>
                  <div className='bg-info bg-opacity-10 rounded p-2 px-3 border border-info'>
                    <small className='text-info'>وحدات التشغيل</small>
                    <div className='fw-bold text-info'>{operatingUnitsCount}</div>
                  </div>
                  <div className='bg-secondary bg-opacity-50 rounded p-2 px-3'>
                    <small className='text-muted'>وحدات أخرى</small>
                    <div className='fw-bold'>{otherOrgsCount}</div>
                  </div>

                  {filterBy === 'operatingUnit' && (
                    <div className='bg-info bg-opacity-20 rounded p-2 px-3 border border-info'>
                      <small className='text-info'>عرض وحدات التشغيل فقط</small>
                      <div className='fw-bold text-info'>{sortedAndFilteredOrg?.length || 0} وحدة</div>
                    </div>
                  )}
                  {filterBy === 'type' && orgType === '30' && (
                    <div className='bg-warning bg-opacity-20 rounded p-2 px-3 border border-warning'>
                      <small className='text-warning'>عرض الشركة الرئيسية فقط</small>
                      <div className='fw-bold text-warning'>{sortedAndFilteredOrg?.length || 0} شركة</div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* مفتاح الألوان وأزرار العرض */}
            <div className='row mb-3'>
              <div className='col-12'>
                <div className='d-flex flex-wrap gap-3 align-items-center justify-content-between'>
                  <div className='d-flex flex-wrap gap-3 align-items-center'>
                    <small className='text-muted fw-bold'>مفتاح الألوان:</small>
                    <div className='d-flex align-items-center gap-1'>
                      <i className='fas fa-crown text-warning'></i>
                      <small>الشركة الرئيسية</small>
                    </div>
                    <div className='d-flex align-items-center gap-1'>
                      <i className='fas fa-cogs text-info'></i>
                      <small>وحدات التشغيل</small>
                    </div>
                  </div>

                  {/* أزرار التبديل بين طرق العرض */}
                  <div className='btn-group btn-group-sm' role='group'>
                    <button
                      type='button'
                      className={`btn ${viewMode === 'table' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setViewMode('table')}
                      title='عرض جدول'
                    >
                      <i className='fas fa-table me-1'></i>
                      جدول
                    </button>
                    <button
                      type='button'
                      className={`btn ${viewMode === 'cards' ? 'btn-theme' : 'btn-outline-theme'}`}
                      onClick={() => setViewMode('cards')}
                      title='عرض بطاقات'
                    >
                      <i className='fas fa-th-large me-1'></i>
                      بطاقات
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* عرض المكون المناسب */}
            <NtxTable
              data={tableData}
              columns={columns}
              dataPerPage={10}
              theadClass='bg-secondary bg-opacity-50'
              tableClass='table table-hover align-middle'
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent id='modalXl' title={t('NewOrganizationalUnit')} size='lg' onClose={() => setShow(false)}>
        {Show && <AddDepartment onSuccess={() => setShow(false)} />}
      </ModalComponent>

      <NeatixModal show={Show2} setShow={setShow2} showHeader={false} size='lg'>
        {id && <EditFormDepartments id={id} onClose={() => setShow2(false)} />}
      </NeatixModal>

      {/* <OperatingUnitsHelpModal setShow={setShowHelpModal} show={ShowHelpModal} /> */}
    </>
  );
};

export default Index;
